<template>
  <div id="mitu">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Mitu'
};
</script>

<style lang="less" scoped>
#mitu {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100svh;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/mitu/App.vue